<template>
  <div style="background-color: #FFFFFF;flex-grow:1;position: relative;min-height: 100%;">
    <ul id="box">
      <!-- <div @click="forben"
           style='position: absolute;top: 0;right:0;font-size: 0.3rem;zIndex:1000'>禁言</div>
      <div @click="notforben"
           style='position: absolute;top: 0;left:0;font-size: 0.3rem;zIndex:100'>解除禁言</div>

      <div @click="userForben"
           style='position: absolute;top: 1rem;right:0;font-size: 0.3rem;zIndex:100'>用户禁言</div>
      <div @click="notUserForben"
           style='position: absolute;top: 1rem;left:0;font-size: 0.3rem;zIndex:100'>用户解除禁言</div> -->
      <template v-if="wxuser">
        <li v-for="(msg,i) in lists"
            :key="i">
          <div v-show="msg.userid!=wxuser.uId&& msg.type!='g'"
               class="content">
            <img :src="msg.uIcon || defaultHead"
                 class="u-icon"
                 alt />
            <span class="other">
              <span style="font-size:0.26rem ;"
                    :class="{'teacher':msg.type==1?true:false}">
                {{msg.username}}
                <span v-if="msg.type==1"
                      class="teacher">(讲师)</span>
              </span>
              <span style="color: #666666;font-size: 0.24rem;"
                    class="dialog-content">{{msg.content}}</span>
            </span>
          </div>
          <div v-show="msg.userid==wxuser.uId && msg.type!='g'"
               class="isMe">
            <img :src="msg.uIcon || defaultHead"
                 alt
                 class="u-icon" />
            <span class="self"
                  v-show="msg.userid==wxuser.uId">
              <span style="color: #FF781B;font-size:0.22rem;"
                    class="nick-name">我</span>
              <span style="color: #666666;font-size: 0.24rem;"
                    class="dialog-content">{{msg.content}}</span>
            </span>
          </div>
          <div class="reword"
               v-if="msg.type=='g'">
            <span>{{msg.username}} 送出</span>
            <img :src="JSON.parse(msg.content).gUrl" />
            <!-- <span>{{rewardList.find(v=>v.gId==msg.content).gUrl}}</span> -->

          </div>
        </li>
      </template>
      <div v-if="!wxuser"
           class="reglogin">
        <router-link :to="{name:'Login'}">立即登录，参与互动</router-link>
      </div>
    </ul>
    <div v-show="wxuser">
      <div v-show="!isForbidden&&!userForBidden"
           class="sendBox">
        <div class="inp_send"
             :style="{'position':isAndIos?'fixed':'absolute'}">
          <img class="reward"
               @click="showReward = true"
               src="./imgs/reward.png"
               alt="">
          <textarea name
                    cols="30"
                    rows="10"
                    placeholder="说说我的看法！"
                    v-model="content"
                    id="inp"></textarea>
          <img src="../../assets/images/send.png"
               alt
               @click="send" />
        </div>

      </div>
      <div v-show="isForbidden||userForBidden"
           class="roomtips">{{forbenDesc}}</div>
    </div>

    <div :class="[showReward?'rewardWrapShow':'rewardWrap','commReward']">
      <ul class="rewardList"
          v-show="!showCustom">
        <li v-for="item in rewardList"
            :key="item.gId"
            @click="sendGift(item)">
          <img :src="item.gUrl"
               alt=""
               srcset="">
          <span>{{item.gName}}</span>
          <b>￥{{item.gMoney}}</b>
        </li>
      </ul>
      <div class="custom"
           v-show="showCustom">
        <div class="topTitle">
          <i class="iconfont"
             @click="showCustom = false">&#xe619;</i>
          自定义金额
        </div>
        <div class="setMoney">
          <span>金额</span>
          <input type="number"
                 placeholder="请输入金额" />
          <span>元</span>

        </div>
        <div class="sureBtn">确认打赏</div>

      </div>

      <div class="closeReward"
           @click="showReward = false">
        <i class="iconfont">&#xe602;</i>
      </div>
    </div>

  </div>
</template>
<script>
import AppSetting from '../../AppSetting.js';
import bus from "../bus/index.js";
import loginService from './../../plugin/extendFn/loginService'
// import vueEmoji from '../emoji/emoji.vue'
console.log(bus);
export default {
  data () {
    return {
      showReward: false, // 是否显示打赏列表
      showCustom: false, // 是否显示自定义钱数
      content: "",
      speakShow: false,
      showEmoji: false,
      zeroCdate: 0,
      lists: [],
      flag: true, //查询数据库开关
      mmsg: "",
      uId: "",
      color: "#0062db",
      chatUname: "", //用户的昵称
      showNameCover: true,
      bottombar: true,
      wxuser: null,
      isAndIos: false,
      socket: io.connect(this.GLOBAL.SOCKETPORT),
      defaultHead: require("../../assets/images/headericon.png"),
      rewardList: [],
      isForbidden: false,  // 聊天室禁言 true 整个房间禁言  false 放开禁言 
      userForBidden: false // 用户被禁言 true 整个房间禁言  false 放开禁言 
    };
  },
  props: {
    dmid: {
      type: String,
      default: () => {
        return "2008";
      }
    },
    height: {
      type: Number
    },
    user: {
      type: Object
    }
  },
  computed: {
    forbenDesc () {
      let desc = '此直播间已经禁言'
      if (!this.isForbidden) {
        if (this.userForBidden) {
          desc = '您已被禁言'
        }

      }
      return desc

    },
    showTime () {
      let zeroCdate = this.zeroCdate;
      let start = 10;
      return this.lists.map((item, i) => {
        if (i < 10) {
          return false;
        } else {
          start =
            Math.floor(i / 10) * 10 > start ? Math.floor(i / 10) * 10 : start;
          if (
            item &&
            this.lists[start] &&
            item.cdate - this.lists[start].cdate > 60000
          ) {
            start = (Math.floor(i / 10) + 1) * 10;
            return true;
          } else {
            return false;
          }
        }
      });
    }
    // selfHeight() {
    //   return this.height-52 + 'px';
    // },
  },
  filters: {
    formatTime (time) {
      let data = new Date().getTime();
      let timesy = new Date(time).Format("yyyy") * 1;
      let timy = new Date(data).Format("yyyy") * 1;
      let timesm = new Date(time).Format("MM") * 1;
      let timm = new Date(data).Format("MM") * 1;
      let timesd = new Date(time).Format("dd") * 1;
      let timd = new Date(data).Format("dd") * 1;

      // console.log(times);
      // console.log(tim);
      if (timesy < timy) {
        return new Date(time).Format("yyyy.MM.dd hh:mm");
      }
      if (timesm != timm) {
        return new Date(time).Format("MM.dd hh:mm");
      }
      if (timesd != timd) {
        return new Date(time).Format("dd hh:mm");
      } else {
        return new Date(time).Format("hh:mm");
      }
    }
  },
  methods: {
    userForben () {
      let param = {
        userid: this.wxuser.uId,
        roomid: this.$route.query.liveId,
        adminid: this.wxuser.uId

      };

      this.socket.emit("roomShutSingle", param);
      
    },
    notUserForben () {
      let param = {
        userid: this.wxuser.uId,
        roomid: this.$route.query.liveId,
        adminid: this.wxuser.uId
      };

      this.socket.emit("roomOpenSingle", param);

    },
    forben () {
      let param = {
        userid: this.wxuser.uId,
        roomid: this.$route.query.liveId,
        adminid: this.wxuser.uId
      };

      this.socket.emit("roomShutAll", param);

    },
    notforben () {
      let param = {
        userid: this.wxuser.uId,
        roomid: this.$route.query.liveId,
        adminid: this.wxuser.uId
      };

      this.socket.emit("roomOpenAll", param);

    },
    onBridgeReady (params, item) {
      console.log(params)
      var that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: params.appId, //公众号名称，由商户传入
          timeStamp: params.timeStamp + "", //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: params.nonceStr, //支付签名随机串，不长于 32 位
          package: params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: params.sign //支付签名
        },
        (res) => {
          if (res.err_msg === "get_brand_wcpay_request:ok") {

            let msgParam = {
              userid: this.wxuser.uId,
              username: this.wxuser.uName
                ? this.wxuser.uName
                : this.wxuser.uUsername
                  ? this.wxuser.uUsername
                  : "",
              usericon: this.wxuser.sIcon,
              roomid: this.$route.query.liveId,
              content: JSON.stringify(item),
              type: "g", //普通消息
              cdate: new Date().getTime()
            };

            this.socket.emit("message", msgParam);
            this.showReward = false

          } else if (res.err_msg === "get_brand_wcpay_request:fail") {

          }
        }
      );
    },

    getGiftList () {
      this.$postHttp(AppSetting.baseUrl + '/common/gift/list', {}).then((res) => {

        let data = res.data
        if (data.code === 0) {
          this.rewardList = data.data
          // this.rewardList.push({
          //   gFl: "1",
          //   gId: 999,
          //   gMoney: 1,
          //   gName: "现金",
          //   gOrder: 1,
          //   type: 2,
          //   gUrl: require('./imgs/reward2.png')
          // })

        }
      });
    },
    sendGift (item) {
      if (item.gMoney == 0) {
        let msgParam = {
          userid: this.wxuser.uId,
          username: this.wxuser.uName
            ? this.wxuser.uName
            : this.wxuser.uUsername
              ? this.wxuser.uUsername
              : "",
          usericon: this.wxuser.sIcon,
          roomid: this.$route.query.liveId,
          content: JSON.stringify(item),
          type: "g", //普通消息
          cdate: new Date().getTime()
        };
        this.socket.emit("message", msgParam);
        this.showReward = false
        return
      }
      let param = {
        orderType: 4, //vip购买，1 视频购买，2直播购买，3会议购买
        bId: this.$route.query.liveId,
        relId: item.gId,
        originalPrice: item.gMoney,
        payPrice: item.gMoney,
        uid: this.wxuser.uId
      };
      this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then(res => {
        if (res.data.code == 0) {
          const pay_params = JSON.parse(res.data.parMap);

          if (typeof WeixinJSBridge === "undefined") {
            console.log('走这里1')
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            }
          } else {
            this.onBridgeReady(pay_params, item);
          }
        } else if (res.data.code == 2) {
          this.toast('购买成功')

        } else {
          this.confirm('授权失败，点击确定微信授权', '取消', '确定', () => {
            return true
          }, () => {
            this.wxlogin()
            return true;
          })
        }
      });



    },
    showRewardList () {
      this.showReward = true
    },
    send () {
      if (this.content == "" || this.content.length < 1) {
        return false;
      } else {
        let msgParam = {
          userid: this.wxuser.uId,
          username: this.wxuser.uName
            ? this.wxuser.uName
            : this.wxuser.uUsername
              ? this.wxuser.uUsername
              : "",
          usericon: this.wxuser.sIcon,
          roomid: this.$route.query.liveId,
          content: this.content,
          type: "m", //普通消息
          cdate: new Date().getTime()
        };
        console.log("shu", msgParam);
        this.content = "";
        this.socket.emit("message", msgParam);
        // setTimeout(() => {
        //   let box = document.getElementById("box");
        //   console.log("里面元素高度", box.scrollHeight);
        //   console.log(box);
        //   box.scrollTop = box.scrollHeight;
        // }, 200);
      }
    },
    cancel () {
      document.getElementById("in").setAttribute("placeholder", "");
      this.content = "";
      this.speakShow = false;
      this.bottombar = true;
    },

    selectEmoji (code) {
      this.showEmoji = false;
      this.content += code;
    },
    submit () {
      // this.send()
      // this.data.push(this.value)
      // this.value = ''
    }
  },
  async mounted () {
    this. wxuser=await loginService.getLoginUser();

    this.getGiftList()
    var u = navigator.userAgent,
      app = navigator.appVersion;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      this.isAndIos = true;
      //这个是安卓操作系统
    }
    if (isIOS) {
      this.isAndIos = false;
      //这个是ios操作系统
    }

    const h = document.body.scrollHeight; // 用onresize事件监控窗口或框架被调整大小，先把一开始的高度记录下来
    window.onresize = function () {
      // 如果当前窗口小于一开始记录的窗口高度，那就让当前窗口等于一开始窗口的高度
      if (document.body.scrollHeight < h) {
        document.body.style.height = 100 + "vh";
      }
    };
    let userId;

    if (this.wxuser == "null" || !this.wxuser) {
      userId = parseInt(Math.random() * 100000000);
    }

    if (!this.socket.connected) {
      this.socket.connect(); //初始化后连接  io.connect(this.GLOBAL.SOCKETPORT)这个是整个socket对象返回的数据
    }

    let param = {
      userid: this.wxuser ? this.wxuser.uId : userId,
      roomid: this.$route.query.liveId,
      username: this.wxuser ? this.wxuser.uName : userId,
      usericon: this.wxuser ? this.wxuser.uIcon : ""
    };
    // console.log('连接参数',param)
    this.socket.emit("login", param);
    bus.$emit("noticeUser", param);
    this.socket.on("connect", () => {
      console.log("监听connect");
    });
    this.socket.on("disconnect", obj => {
      // alert('断开了')
      console.log("断开连接---");
      this.socket = io.connect(this.GLOBAL.SOCKETPORT); //监听重新连接
      console.log(param);
      this.socket.emit("login", param);
    });
    let self = this;
    this.socket.on("online", function (data) {
      self.$emit("onlineuser", data.online_count);
      console.log("online user is :" + data.online_count);
    });

    this.socket.on("stat", function (data) {
      //葛兰素史克在线累计人数
      self.$emit("onlinecount", data.view_count);
    });

    this.socket.on("message", obj => {
      console.log(
        "收到来自服务端的普通消息,房间号====" + this.$route.query.liveId
      );
      // console.log(obj)
      let person = {
        userid: obj.userid,
        username: obj.username,
        usericon: obj.usericon,
        content: obj.content,
        roomid: this.$route.query.liveId,
        type: obj.type, //欢迎消息
        cdate: new Date().getTime()
      };
      console.log("message------>", person);

      this.lists.push(person);
      setTimeout(() => {
        let box = document.getElementById("box");
        console.log("里面元素高度", box.scrollHeight);
        console.log(box);
        box.scrollTop = box.scrollHeight;
      }, 200);
    });
    this.socket.on("queryAll", results => {
      console.log("LIEBIAO", results);
      this.lists = results;
      this.flag = false;
      setTimeout(() => {
        let box = document.getElementById("box");
        // console.log('里面元素高度',box.scrollHeight)
        box.scrollTop = box.scrollHeight;
      }, 200);
    });
    this.socket.on("roomShutAll", results => {

      this.isForbidden = true

    });
    this.socket.on("roomOpenAll", results => {

      this.isForbidden = false
    });

    this.socket.on("roomShutSingle", results => {

      if (this.wxuser.uId == results.userid) {

        this.userForBidden = true
      }


    });
    this.socket.on("roomOpenSingle", results => {

      if (this.wxuser.uId == results.userid) {
        this.userForBidden = false
      }
    });

  },
  destroyed () {
    // alert('退出聊天')
    this.socket.close();
    this.socket.removeAllListeners(); //清空聊天监听的数据
  },

  components: {}
};
</script>
<style scoped="scoped" lang="scss">
input {
  -webkit-appearance: none; /*去除input默认样式*/
}
#box {
  background: #ffffff;
  overflow-y: scroll;
  width: 100vw;
  height: 100%;
  padding: 0 0.29rem;
  padding-bottom: 1rem;
  box-sizing: border-box;
  position: relative;
  li {
    width: 100%;
    padding: 0.05rem 0;
  }
  .reglogin {
    font-size: 0.28rem;
    text-align: center;
    line-height: 100%;
    position: relative;
    margin-top: 2rem;
    top: 50%;
    a {
      color: #0e94ff;
      text-underline: #0e94ff;
    }
  }
  .reword {
    font-size: 0.22rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.2rem;
    color: #999;

    img {
      width: 0.6rem;
      height: 0.6rem;
      margin-left: 0.2rem;
    }
  }
}
.u-icon {
  margin-right: 5px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
}
.dialog-content {
  padding: 5px;
  border-radius: 5px;
  background: #f0f0f0;
  border-top-right-radius: 0;
  word-break: break-all;
}
.content {
  display: flex;
  align-items: center;
}
.isMe {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  .nick-name {
    text-align: right;
  }
}
.inp_send {
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
  height: 1rem;
  padding: 0 0.28rem;
  box-sizing: border-box;
  z-index: 100;
  bottom: 0;
  textarea {
    width: 6.2rem;
    height: 0.7rem;
    border: 1px solid #e6e6e6;
    -webkit-appearance: none;
    outline: none;
    border-radius: 34px;
    padding-left: 0.31rem;
    padding-top: 0.15rem;
    padding-bottom: 0.1rem;
    box-sizing: border-box;
    font-size: 0.24rem;
  }
  textarea::placeholder {
    color: #999999;
    /*line-height: 0.7rem;*/
  }

  img {
    width: 0.48rem;
    height: 0.48rem;
    margin-left: 0.17rem;
  }
  .reward {
    margin-left: 0;
    margin-right: 0.2rem;
    width: 0.6rem;
    height: 0.6rem;
  }
}
.box {
  background-color: #f4f5f4;
}
.sendBox {
  /*position: sticky;*/
  position: fixed;
  bottom: 0;
  font-size: 0;
  left: 0;
  height: 1rem;
  /*padding-left: .1rem;*/
  width: 100vw;
  border-top: 1px solid #e6e6e6;
  z-index: 1000;
}
.roomtips {
  position: absolute;
  bottom: 0rem;
  left: 0;

  width: 100%;
  height: 0.7rem;
  font-size: 0.3rem;
  text-align: center;
  line-height: 0.7rem;
  border-top: 1;
  background: #e6e6e6;

  font-size: 0.26rem;
  color: #333;
  // margin: 0 auto;
}

.welcome {
  color: red;
}
.me {
  color: #ff781b;
  font-size: 0.28rem;
  vertical-align: middle;
}
input {
  width: 5.8rem;
  /*height: rem;*/
  font-size: 0.3rem;
  /*border-radius: .2rem;*/
  border: 1px solid #e9e9e9;
}

.self {
  color: #5cadff;
  display: flex;
  flex-direction: column;
  justify-content: start;
  /*flex-wrap: wrap;*/
  max-width: 100%;
  margin-right: 5px;
  span:nth-of-type(1) {
    flex-shrink: 0;
    max-width: 100%;
  }
  span {
    display: inline-block;
  }
}

.other {
  display: flex;
  flex-direction: column;
  color: #5cadff;
  justify-content: start;
  /*flex-wrap: wrap;*/
  max-width: 100%;
  .teacher {
    color: #b10000 !important;
  }
  span:nth-of-type(1) {
    flex-shrink: 0;
    max-width: 100%;
    color: #21afff;
  }
  span {
    display: inline-block;
  }
}
.other span {
  color: #333333;
}
.admin span {
}

.con {
  /*padding: .1rem .05rem;*/
  border-radius: 0.1rem;
  display: inline-block;
  position: relative;
  /*max-width: 80%;*/
  line-height: 1.25;
  display: inline-block;
  /*padding: 0.1rem 0.2rem;*/
  color: #666;
  font-size: 0.28rem;
}
.left3 {
  display: inline-block;
  margin-top: 5px;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 10px solid #ffffff;
}
.right3 {
  display: inline-block;
  margin-top: 5px;
  margin-left: -4px;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 10px solid #ffffff;
}
.msgitem * {
  vertical-align: top;
}

.self .con {
  text-align: left;
}

.other .con {
  color: #333333;
  background: rgb(244, 245, 244);
}
.commReward {
  position: fixed;
  width: 100vw;
  height: 4.2rem;
  bottom: -4.5rem;
  transition: bottom 1s;
  left: 0;
  z-index: 9999;
  background: #f5f5f9;
  // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.24), 0 1px 5px 0 rgba(0, 0, 0, 0.16);
  .rewardList {
    overflow: hidden;
    display: flex;
    align-content: flex-start;

    flex-wrap: wrap;
    li {
      width: 1.5rem;
      flex-wrap: wrap;
      padding-top: 0.2rem;
      // flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 0.2rem;
      &:nth-last-child(1) {
        img {
          width: 0.5rem;
          height: auto;
        }
      }

      img {
        width: 0.8rem;
        height: 0.8rem;
      }

      b {
        font-size: 0.24rem;
        color: #999;
      }
    }
  }
  .closeReward {
    position: absolute;
    left: 50%;
    bottom: -0.2rem;
    margin-left: -0.2rem;

    z-index: 10000;
    .iconfont {
      font-size: 0.4rem;
    }
  }
  .custom {
    font-size: 0.3rem;
    .topTitle {
      line-height: 0.7rem;
      border-bottom: 1px solid #e6e6e6;
      font-size: 0.28rem;
      text-align: center;
      color: #333;
      position: relative;
      .iconfont {
        position: absolute;
        left: 0.2rem;
        top: 0.02rem;
        font-size: 0.3rem;
        transform: rotate(180deg);
      }
    }
    .setMoney {
      font-size: 0.24rem;
      background: #fff;
      width: 3.5rem;
      display: flex;
      height: 0.6rem;
      align-items: center;
      border-radius: 5px;
      margin: 0 auto;
      margin-top: 0.8rem;
      padding: 0 0.2rem;

      input {
        font-size: 0.24rem;
        outline: none;
        border: 0;
        width: 1.5rem;
        margin-left: 1.2rem;
      }
    }
    .sureBtn {
      width: 5rem;
      height: 0.7rem;
      margin: 0 auto;
      text-align: center;
      background: #f35135;
      color: #fff8c6;
      line-height: 0.7rem;
      border-radius: 2rem;
      margin-top: 0.6rem;
    }
  }
}
.rewardWrapShow {
  transition: bottom 0.8s;
  bottom: 0;
}
.rewardWrap {
  bottom: -4.5rem;
  transition: bottom 0.8s;
}
</style>



// WEBPACK FOOTER //
// src/components/iChat/iChat.vue